module.exports = __webpack_public_path__ + "static/media/Test55.ef06284c.bmp";